<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card
      class="mt-3"
      v-else-if="!this.loading && !this.errormessage"
    >
      <el-table
        :data="rowData"
        header-row-class-name="text-danger"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        v-if="rowData.length > 0"
      >
        <el-table-column
          label="Day"
          property="CourseDay"
          class-name="d-none d-md-table-cell text-center"
          width="50px"
        />
        <el-table-column
          label="Title"
          property="Title"
          class-name="text-break text-left"
        />
        <el-table-column
          label="Presenter"
          property="PresenterName"
          class-name="text-center"
        />
        <el-table-column
          class-name="d-none d-md-table-cell text-center"
          label="Backup"
          property="BackupName"
          width="100px"
        />
        <el-table-column
          class-name="d-none d-md-table-cell"
          label="Location"
          property="PresentationLocation"
          width="120px"
        />
        <el-table-column
          label="Audience"
          class-name="d-none d-md-table-cell text-center"
          property="Audience"
          width="100px"
        />
        <el-table-column
          label="Notes"
          property="Notes"
          class-name="d-none d-md-table-cell text-center"
          width="100px"
        />
        <el-table-column
          label="Reference"
          property="CurriculumReference"
          class-name="d-none d-md-table-cell text-center"
          width="100px"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          label="Assign"
        >
          <template slot-scope="props">
            <p-button
              type="success"
              class="mt-1 mb-1"
              size="sm"
              title="Assign Presenter"
              icon
              @click="showAssignDialog(props.row)"
            >
              <i class="ti ti-receipt" />
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        class="text-center"
      >
        <p class="card-category">
          There are no staff members assigned to this course.
        </p>
      </div>
    </card>
    <modal
      :show.sync="showEdit"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      type="mini"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6>
          <i class="ti ti-receipt mr-2" />
          <span class="text-danger">Assign Presenters & Update Notes</span>
        </h6>
      </div>
      <div class="col-12">
        <fg-input>
          <label>Please select a Presenter</label>
          <el-select
            class="select-default2"
            size="large"
            name="presenter"
            placeholder=""
            clearable
            v-model="presentationUpdate.PresenterScouterKey"
          >
            <el-option
              v-for="(data, index) in staff"
              class="select-default2"
              :value="index"
              :label="data"
              :key="data"
            />
          </el-select>
        </fg-input>
        <fg-input>
          <label>Please select a Backup</label>
          <el-select
            class="select-default2"
            size="large"
            clearable
            name="backup"
            placeholder=""
            v-model="presentationUpdate.BackupScouterKey"
          >
            <el-option
              v-for="(data, index) in staff"
              class="select-default2"
              :value="index"
              :label="data"
              :key="data"
            />
          </el-select>
        </fg-input>
        <fg-input
          name="location"
          title="Location"
          label="Location"
          v-model="presentationUpdate.PresentationLocation"
        />
        <div class="form-group">
          <label>Notes</label>
          <textarea
            rows="4"
            style="height:100%;"
            class="form-control border-input"
            placeholder=""
            v-model="presentationUpdate.Notes"
          />
        </div>
      </div>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showEdit = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          @click="save"
        >
          Save
        </p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import presentationApi from '@/services/api/presentation'
import scouterApi from '@/services/api/scouter'
import oops from '@/components/_main/oops.vue'
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'PresentationEdit',
  components: {
    oops,
    Modal
  },
  data: function () {
    return {
      cellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px'
      },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      rowData: null,
      loading: true,
      errormessage: null,
      staff: null,
      showEdit: false,
      selectedParams: null,
      presentationUpdate: {},
      tempHolding: null
    }
  },
  mounted () {
    presentationApi
      .list(this.$root.courseKey)
      .then(x => {
        this.rowData = x
        this.getStaffList()
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {})
  },
  methods: {
    showAssignDialog: function (row) {
      this.presentationUpdate = row
      this.showEdit = true
    },
    save: function () {
      this.updatePresentationDetail(this.presentationUpdate)
      this.showEdit = false
    },
    getStaffList: function () {
      scouterApi
        .getStaffLookups(this.$root.courseKey)
        .then(y => {
          this.staff = y
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePresentationDetail: function (PresentationDetail) {
      presentationApi
        .update(this.$root.courseKey, PresentationDetail)
        .then(x => {
          this.rowData = x
          this.$notify({
            message: 'The update is complete.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating the presentation assignment.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    }
  }
}
</script>
